import React, { useState, useEffect } from "react";
import { ArrowRight, Trash } from "lucide-react";

interface Association {
  user_id: string;
  profile_id: string;
}

interface AssociationItemProps {
  association: Association;
  isDarkMode: boolean;
  isMobile: boolean;
  onDelete: (userId: string) => Promise<void>;
}

const AssociationItem = ({
  association,
  isDarkMode,
  isMobile,
  onDelete
}: AssociationItemProps) => {

  const [textConfig, setTextConfig] = useState<any>({});

  const fetchTextConfig = async () => {
    try {
      const response = await fetch("/text.json");
      const data = await response.json();
      setTextConfig(data);
    } catch (error) {
      console.error("Error loading text config:", error);
    }
  };

  useEffect(() => {
    fetchTextConfig();
  }, []);

  const handleDelete = () => {
    onDelete(association.user_id);
  };

  return (
    <div className="flex flex-col w-full">
      <div className="hidden md:flex items-center mb-1">
        <span className="text-lg font-medium mr-3 truncate flex-shrink-0 max-w-[200px]">
          {association.user_id}
        </span>
        <ArrowRight size={20} className="text-gray-400 mx-2 flex-shrink-0" />
        <span className="text-[#1BCF66] border border-[#1BCF66] px-3 py-1 rounded-full text-sm truncate flex-shrink-0 max-w-[200px]">
          {association.profile_id}
        </span>
        <div className="flex-grow"></div>
      </div>

      <div className="flex md:hidden flex-col space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex-1 min-w-0">
            <span className="text-lg font-medium block truncate">
              {association.user_id}
            </span>
            <span className="text-xs text-gray-500">{textConfig.ASSOCIATION_ITEM_USER_LABEL}</span>
          </div>
        </div>
        
        <div className="flex-1 min-w-0">
          <span className="text-[#1BCF66] border border-[#1BCF66] px-3 py-1 rounded-full text-sm block truncate w-fit max-w-full">
            {association.profile_id}
          </span>
          <span className="text-xs text-gray-500 mt-1 block">{textConfig.ASSOCIATION_ITEM_PROFILE_ASSIGNED}</span>
        </div>
      </div>

      <span className="text-sm text-[#ACBECC] mt-2 md:mt-0">
        {textConfig.ASSOCIATION_ITEM_DESCRIPTION?.replace('{user}', association.user_id).replace('{profile}', association.profile_id)}
      </span>
    </div>
  );
};

export default AssociationItem;